import { useState } from 'react';
import _ from 'lodash';
import Router, { useRouter } from 'next/router';
import styled from 'styled-components';
import { Drawer, Icon, Select, Modal } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import * as CartQuery from '../../views/cart/queries';
import { addConversionScript } from '../../lib/addNaverAdLogScript';
import { addConversionDaumScript } from '../../lib/addDaumAdLogScript';

const { Option } = Select;
const CartModal = ({ cartModal, setCartModal }) => {
  const router = useRouter();
  const handleOk = () => {
    const productId = _.get(router, 'query.productId');
    Router.push({
      pathname: '/cart',
      query: { productId }
    }).then(() => {
      window.scrollTo(0, 0);
    });
  };
  const handleCancel = () => {
    setCartModal(false);
  };
  return (
    <Modal zIndex={1000} okText="확인" visible={cartModal} closable={false} footer={null}>
      <p style={{ textAlign: 'center' }}>선택한 상품이 장바구니에 담겼습니다</p>
      <KeepShoppingBtn onClick={handleCancel}>계속 쇼핑하기</KeepShoppingBtn>
      <CartButton onClick={handleOk}>장바구니 확인</CartButton>
    </Modal>
  );
};
const OptionSelection = ({ product, productOptions, setState, state }) => {
  const handleOnClose = () => {
    setState(false);
  };
  const [selectedOption, setSelectedOption] = useState({
    options: []
  });
  const selectedListExist = !_.isEmpty(selectedOption.options);
  const filterTotalPrice = _.sumBy(selectedOption.options, function(params) {
    return params.discountedPrice * params.amount;
  });
  const handleChange = id => {
    const findSelectedOptions = _.filter(productOptions, { id });
    setSelectedOption({
      ...selectedOption,
      options: _.uniqBy(
        selectedOption.options.concat({
          name: findSelectedOptions[0].name,
          price: findSelectedOptions[0].price,
          discountedPrice: findSelectedOptions[0].discountedPrice,
          productVariant: findSelectedOptions[0].id,
          amount: 1
        }),
        'productVariant'
      )
    });
  };
  const createCartInput = _.map(selectedOption.options, function(params) {
    return _.pick(params, ['productVariant', 'amount']);
  });
  const handleChangeQuantity = (productVariant, name) => {
    const findOptions = _.filter(selectedOption.options, { productVariant });
    if (name === 'increase') {
      findOptions[0].amount += 1;
      setSelectedOption({
        ...selectedOption,
        ...findOptions
      });
    } else {
      findOptions[0].amount -= 1;
      setSelectedOption({
        ...selectedOption,
        ...findOptions
      });
    }
  };
  const handleRemoveVariant = id => () => {
    _.remove(selectedOption.options, function(params) {
      return params.productVariant === id;
    });
    console.log(selectedOption.options);
    setSelectedOption({
      ...selectedOption
    });
  };
  const [cartModal, setCartModal] = useState(false);
  const [createUpdateCart] = useMutation(CartQuery.CREATE_UPDATE_CART, {
    refetchQueries: [{ query: CartQuery.USER_CARTS }]
  });
  const handleCart = () => {
    setCartModal(true);
    createUpdateCart({
      variables: {
        input: createCartInput
      }
    });
    // 네이버 & 다음 광고 로그분석 전환 스크립트 (장바구니 담기)
    if (setCartModal) {
      addConversionScript(3, 1);
      addConversionDaumScript('viewCart', '장바구니완료');
    }

    // Setting GA : 장바구니 담기 (일반주문)
    const { options } = selectedOption;
    window.dataLayer.push({
      event: 'add_to_cart',
      hurdlers_ga4: {
        items: options.map(item => ({
          item_id: _.get(product, 'id', ''),
          item_name: _.get(product, 'name', ''),
          item_category: _.get(product, 'productCategory.name', ''),
          item_varient: _.get(item, 'name', ''),
          price: _.get(item, 'price', ''),
          quantity: _.get(item, 'amount', ''),
          discount: _.get(item, 'discountedPrice', ''),
          item_type: _.get(product, 'code', '')
        }))
      }
    });
  };
  const optionName = _.last(_.get(selectedOption, 'options'));
  return (
    <>
      {cartModal && <CartModal cartModal={cartModal} setCartModal={setCartModal} />}
      <SelectionContainer placement="bottom" closable={false} onClose={handleOnClose} visible={state} key="bottom" height="auto" zIndex={900}>
        <CloseButton onClick={handleOnClose}>
          <Icon type="down" />
        </CloseButton>
        <OptionSelect style={{ width: '100%' }} placeholder="옵션을 선택해주세요." value={_.get(optionName, 'name')} onChange={handleChange}>
          {productOptions &&
            productOptions.map(({ id, shortName }) => {
              return <Option value={id}>{shortName}</Option>;
            })}
        </OptionSelect>
        {/* 선택한 옵션 */}
        {selectedOption.options &&
          selectedOption.options.map(variant => {
            return (
              <>
                <SelectedOption key={variant.productVariant}>
                  <OptionCard>
                    <SelectedName>{variant.name}</SelectedName>
                    <Amount>
                      <Minus type="button" name="decrease" aria-label="수량 1개 제거" onClick={() => handleChangeQuantity(variant.productVariant, 'decrease')}>
                        <Icon type="minus" style={{ color: '#00129a', fontSize: '1.4rem' }} />
                      </Minus>
                      <Quantity>{variant.amount}</Quantity>
                      <Plus type="button" name="increase" aria-label="수량 1개 추가" onClick={() => handleChangeQuantity(variant.productVariant, 'increase')}>
                        <Icon type="plus" style={{ color: '#00129a', fontSize: '1.4rem' }} />
                      </Plus>
                      <Price price>{(variant.price * variant.amount).toLocaleString()}원</Price>
                      <Price>{(variant.discountedPrice * variant.amount).toLocaleString()}원</Price>
                    </Amount>
                  </OptionCard>
                  <RemoveButton onClick={handleRemoveVariant(variant.productVariant)}>
                    <Icon type="close" />
                  </RemoveButton>
                </SelectedOption>
              </>
            );
          })}
        <TotalPrice>
          <span>총 상품 금액</span>
          {filterTotalPrice.toLocaleString()}원
        </TotalPrice>
        {!selectedListExist ? (
          <Button>장바구니 담기</Button>
        ) : (
          <ButtonGroup>
            <AddCartButton onClick={handleCart}>장바구니 담기</AddCartButton>
          </ButtonGroup>
        )}
      </SelectionContainer>
    </>
  );
};
const SelectionContainer = styled(Drawer)`
  .ant-drawer-content {
    background-color: #f7f7f7;
  }
  ${props => props.theme.device.md} {
    .ant-drawer-body {
      width: 600px;
      margin: 0 auto;
      padding-top: 5rem;
      padding-bottom: 5rem;
    }
  }
`;
const CloseButton = styled.div`
  cursor: pointer;
  width: 80px;
  height: 18px;
  background-color: #f7f7f7;
  position: absolute;
  top: -18px;
  right: 50%;
  transform: translateX(50%);
  text-align: center;
`;
const OptionSelect = styled(Select)`
  .ant-select-selection {
    border: 1px solid #b2b2b2;
    height: 40px;
  }
  .ant-select-selection__rendered {
    line-height: 40px;
  }
  ${props => props.theme.device.md} {
    font-size: 1.8rem;
  }
`;
const SelectedOption = styled.div`
  width: 100%;
  border: 1px solid #b2b2b2;
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 5px;
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;
const OptionCard = styled.div`
  width: 100%;
`;
const RemoveButton = styled.span`
  cursor: pointer;
`;
const SelectedName = styled.div`
  font-weight: 700;
  width: 210px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${props => props.theme.device.md} {
    font-size: 1.6rem;
  }
`;
const Amount = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;
const Minus = styled.button`
  width: 2.4rem;
  height: 2.4rem;
  border: 1px solid #b2b2b2;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Plus = styled(Minus)``;
const Quantity = styled.span`
  width: 32px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border: 1px solid #b2b2b2;
`;
const Price = styled.span`
  text-decoration: ${props => (props.price ? 'line-through' : 'none')};
  color: ${props => (props.price ? '#bdbdbd' : 'inherit')};
  font-weight: ${props => (props.price ? '600' : '800')};
  margin-left: ${props => (props.price ? '16px' : '5px')};
  ${props => props.theme.device.md} {
    font-size: 1.6rem;
  }
`;
const TotalPrice = styled.div`
  width: 100%;
  border-bottom: 2px solid #fff;
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
  align-items: center;
  font-size: 2rem;
  font-weight: 800;
  span {
    font-size: 1.4rem;
    font-weight: 700;
    margin-right: 20px;
  }
`;
const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  /* margin-bottom: 4rem; */
  ${props => props.theme.device.md} {
    margin-bottom: 0rem;
  }
`;
const Button = styled.button`
  cursor: ${props => (props.active ? 'pointer' : 'default')};
  width: 100%;
  background-color: ${props => (props.active ? '#ff7e1f' : '#bcbcbc')};
  color: #fff;
  height: 4.8rem;
  margin-top: 3rem;
  border-radius: 5px;
  font-size: 1.4rem;
  font-weight: 700;
  ${props => props.theme.device.md} {
    font-size: 1.8rem;
    height: 5.2rem;
  }
`;
const AddCartButton = styled(Button)`
  cursor: pointer;
  background-color: #ff7e1f;
  color: #fff;
  margin-right: 0.5rem;
`;
const KeepShoppingBtn = styled(Button)`
  border: 1px solid #ff7e1f;
  background-color: #fff;
  color: #ff7e1f;
  cursor: pointer;
`;
const CartButton = styled(Button)`
  cursor: pointer;
  background-color: #ff7e1f;
`;
export default OptionSelection;
